import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import { useEffect } from 'react';
// 当value的值在dataSource中不存在时，调用一次接口获取数据
export default function useInitRequest(params) {
    const { value, filterLocal, useDetailValue, requestService, initRequestService, lru, mutate, } = params;
    useEffect(() => {
        if (filterLocal || useDetailValue)
            return;
        if (!isNumber(value) && !isString(value) && !Array.isArray(value))
            return;
        const listValue = Array.isArray(value) ? value : [value];
        const newValue = listValue.filter((item) => !lru?.get(item));
        if (isEmpty(newValue))
            return;
        if (!isFunction(initRequestService)) {
            newValue.reduce((pre, cur) => {
                const result = requestService(cur);
                pre = pre.finally(() => {
                    return result.then((data) => {
                        data?.forEach((item) => {
                            lru?.set(item.value, item);
                        });
                        mutate((dataSource = []) => {
                            const safeDataSource = Array.isArray(dataSource)
                                ? dataSource
                                : [];
                            return [...safeDataSource, ...data];
                        });
                    });
                });
                return pre;
            }, Promise.resolve());
        }
        else {
            initRequestService(value).then((data) => {
                data?.forEach((item) => {
                    lru?.set(item.value, Promise.resolve(item));
                });
                mutate((dataSource) => {
                    const safeDataSource = Array.isArray(dataSource) ? dataSource : [];
                    return [...safeDataSource, ...data];
                });
            });
        }
    }, [value]);
}
